<template>
  <modal name="option-modal" class="option-modal"
         :width="650"
         :height="'auto'"
         @before-open="handlerBeforeOpen"
         @before-close="handlerBeforeClose"
  >
    <div class="modal_title">옵션</div>
    <div class="pl30 pr30 pb30">
      <div class="btn_box text-center mt20">
        <el-button class="reg_btn_out" @click="closeModal()">학인</el-button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "OptionModal",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    handlerBeforeOpen(event) {

    },
    handlerBeforeClose() {
      this.$router.replace(this.$route.path);
    },
    closeModal() {
      this.$modal.hide('option-modal')
    },
    movePage(){
      this.$router.push()
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>